import { render, staticRenderFns } from "./common-error.vue?vue&type=template&id=5fcc6b36&scoped=true"
import script from "./common-error.vue?vue&type=script&lang=js"
export * from "./common-error.vue?vue&type=script&lang=js"
import style0 from "./common-error.vue?vue&type=style&index=0&id=5fcc6b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcc6b36",
  null
  
)

export default component.exports